require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2018-06-29-interior-iv.json") })
        }
      }, "path---works-2018-06-29-interior-iv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2018-06-29-interior-iv!./.cache/json/works-2018-06-29-interior-iv.json
// module id = 417
// module chunks = 231608221292675